// extracted by mini-css-extract-plugin
export default {"App":"Game_App__oMhfo","App-logo":"Game_App-logo__D8cjO","Appheader":"Game_Appheader__XAmpH","Title":"Game_Title__-SADW"};